/** Shopify section lifecycle. This bootstrap is safe to include more than once. */
(() => {
  const key = '__magneticBraceletRuntime';
  if (window[key]) { window[key].scan(document); return; }
  const selector = '[data-bracelet-section]';
  const instances = new Map();
  const revisions = new WeakMap();
  let suspended = false;
  function rootsWithin(container) {
    const roots = [...(container?.querySelectorAll?.(selector) || [])];
    if (container?.matches?.(selector)) roots.unshift(container);
    return roots;
  }
  function stop(root) {
    const instance = instances.get(root);
    if (!instance) return;
    instances.delete(root);
    revisions.set(root, (revisions.get(root) || 0) + 1);
    instance.destroy?.();
  }
  function fallback(root, error) {
    root.classList.remove('motion-ready');
    root.querySelectorAll('.reveal').forEach(element => element.classList.add('visible'));
    root.querySelectorAll('[data-story-scene]').forEach(scene => { scene.classList.remove('scene-ready'); scene.classList.add('scene-failed'); scene.dataset.status = 'fallback'; });
    const hero = root.querySelector('#hero-experience');
    if (hero) { hero.classList.remove('is-3d-ready'); hero.dataset.preview = 'photo'; }
    root.querySelectorAll('.scene-poster, #hero-poster').forEach(poster => { poster.hidden = false; poster.setAttribute('aria-hidden', 'false'); });
    root.querySelectorAll('[data-scene-action], [data-hero-action]').forEach(button => { button.disabled = true; });
    root.querySelectorAll('.scene-status, #hero-3d-status').forEach(status => { status.classList.remove('sr-only'); status.textContent = 'The product photograph is shown. Interactive 3D could not load.'; });
    root.dataset.braceletRuntime = 'fallback';
    console.warn('Bracelet experience could not load.', error);
  }
  async function start(root) {
    if (suspended || !root.isConnected || instances.has(root)) return;
    const kind = root.dataset.braceletSection;
    if (kind !== 'home' && kind !== 'product') return;
    let config = {};
    try { config = JSON.parse(root.querySelector('[data-bracelet-config]')?.textContent || '{}'); } catch (_) {}
    const assets = config.assets || window.MB_ASSETS || {};
    const url = assets[kind === 'home' ? 'app.js' : 'product.js'];
    const revision = (revisions.get(root) || 0) + 1;
    revisions.set(root, revision);
    const instance = { destroy: null };
    instances.set(root, instance);
    try {
      if (!url) throw new Error('Missing storefront module URL');
      const module = await import(url);
      if (suspended || !root.isConnected || instances.get(root) !== instance || revisions.get(root) !== revision) return;
      const mount = kind === 'home' ? module.mountHome : module.mountProduct;
      if (typeof mount !== 'function') throw new Error('Missing storefront section controller');
      const controller = mount(root);
      const destroy = typeof controller === 'function' ? controller : controller?.destroy?.bind(controller);
      if (suspended || instances.get(root) !== instance || !root.isConnected) { destroy?.(); return; }
      instance.destroy = destroy;
    } catch (error) {
      if (instances.get(root) === instance && root.isConnected) fallback(root, error);
    }
  }
  function scan(container) {
    for (const root of instances.keys()) if (!root.isConnected) stop(root);
    rootsWithin(container).forEach(start);
  }
  function unload(container) { rootsWithin(container).forEach(stop); }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  document.addEventListener('webglcontextrestored', event => {
    const root = event.target.closest?.(selector);
    if (root && !suspended) { stop(root); start(root); }
  }, true);
  window.addEventListener('pagehide', () => { suspended = true; [...instances.keys()].forEach(stop); });
  window.addEventListener('pageshow', () => { suspended = false; scan(document); });
  window[key] = { scan, unload, count: () => instances.size };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
